/* eslint-disable @typescript-eslint/no-explicit-any */
import lendingApi from 'apis/lending'
import { constants } from 'apps'
import HorseItem from 'features/Market/components/HorseItem'
import { RequestLoginModal } from 'features/Race/components'
import { useDebounce, useToggle, useUpdateEffect } from 'hooks'
import { defaultRegionFilters, LendingHorse, MyAssetSortType, MyHorseListParams, TypeSorts } from 'models'
import { useEffect, useState } from 'react'
import { OneLineTitle, SearchInput } from 'shared'
import SelectCustom from 'shared/SelectCustom'
import { handleAsyncRequest } from 'utils/helper'
import MyBorrowStyled from './styled'
import { NUMBER, STRING_REGION } from 'apps/constants'

export type IMyBorrowProps = {
  isActive: boolean
}


const defaultTypeSort: TypeSorts = [
  {
    name: MyAssetSortType.Decrease,
    isActive: false
  },
  {
    name: MyAssetSortType.Ascending,
    isActive: false
  }
]

export default function MyBorrow() {
  const myHorseListParams: MyHorseListParams = {
    limit: NUMBER.TWENTY,
    page: NUMBER.ONE,
    sort: 'horse_id-asc'
  }
  const [total, setTotal] = useState()
  const [searchValue, setSearchValue] = useState<string>('')
  const [classSelect, setClassSelect] = useState('Sorted by...')
  const [listHorse, setListHorse] = useState<LendingHorse[]>([])
  const debounceSearchValue = useDebounce<string>(searchValue, constants.DEBOUNCE_TIME)

  const [params, setParams] = useState<MyHorseListParams>(myHorseListParams)
  const [isFetch, setIsFetch] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isRequestLoginModalOpen, toggleIsRequestLoginModalOpen] = useToggle(false)
  const [regionSelect, setRegionSelect] = useState('Region')

  const fetchListRaces = async () => {
    setIsLoading(true)
    const [error, result]: any = await handleAsyncRequest(lendingApi.getHorseMyBorrow({ ...params }))
    if (error) {
      setIsLoading(false)
      if (error.code === 403) {
        toggleIsRequestLoginModalOpen(true)
      }
      return
    }
    const records = result?.data.records
    setListHorse(params.page > NUMBER.ONE ? [...listHorse, ...records] : records)
    setTotal(result?.data.total)
    setIsFetch(false)
    if (records && records.length === 0) {
      // setLoader(true)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (isFetch) {
      setListHorse([])
      setSearchValue('')
      setParams({ ...params, page: NUMBER.ONE })
    }
  }, [isFetch])

  useUpdateEffect(() => {
    setListHorse([])
    setParams({ ...params, page: NUMBER.ONE, horseName: debounceSearchValue })
  }, [debounceSearchValue])

  useEffect(() => {
    fetchListRaces()
  }, [params])

  const handleSearchValueChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }

  const handleClassFilterClicked = (item: string) => {
    setParams({
      ...params, page: NUMBER.ONE, sort: item === MyAssetSortType.Decrease ? 'horse_id-desc' : 'horse_id-asc'
    })
    setClassSelect(item)
  }

  const hanldeViewMore = () => {
    setParams({ ...params, page: params.page + NUMBER.ONE })
  }

  const handleNameHorse = () => {
    if (total === NUMBER.ZERO || total === NUMBER.ONE) {
      return 'Horse'
    } else return 'Horses'
  }

  const handleRegionFilterClicked = (item: string) => {
    if (item?.toUpperCase() === STRING_REGION.SEOUL || item?.toUpperCase() === STRING_REGION.TOKYO) {
      setParams({
        ...params, page: NUMBER.ONE, region: item?.toUpperCase()
      })
    } else {
      setParams({
        ...params, page: NUMBER.ONE, region: ''
      })
    }
    setRegionSelect(item)
  }

  return (
    <MyBorrowStyled>
      <div className='my-borrow-container'>
        <div className='top-lending'>
          <OneLineTitle text={handleNameHorse()} total={total} isLending />
          <div className='lending-search'>
            <SearchInput
              searchValue={searchValue}
              handleSearchValueChanged={handleSearchValueChanged}
              customClass='search-horse-input'
              placeholder={'Search'}
            />
            <SelectCustom
              dataSelect={defaultRegionFilters}
              nameSelect={regionSelect}
              onSelected={handleRegionFilterClicked}
            />
            <SelectCustom
              dataSelect={defaultTypeSort}
              nameSelect={classSelect}
              onSelected={handleClassFilterClicked}
            />
          </div>
        </div>
        <HorseItem isLoading={isLoading} total={total} listHorse={listHorse} onViewMore={hanldeViewMore} />
      </div>
      {isRequestLoginModalOpen && <RequestLoginModal toggleIsModalOpen={toggleIsRequestLoginModalOpen} />}
    </MyBorrowStyled>
  )
}
